import { SlidersHorizontal, X } from 'lucide-react';
import { type ReactNode, useState } from 'react';
import { cn } from '../../lib/cn';
import { Button } from '../../ui/Button';
import { CountPill } from '../../ui/CountPill';
import { Sheet } from '../../ui/Dialog';

/**
 * „Filtry” na telefonie (DECISIONS 2026-10-17 [P] „Telefon…”: „filtry w panelu”; wzorzec z Zadań): przycisk 44 px
 * z licznikiem aktywnych filtrów (pigułka akcentu) otwiera dolny panel z kontrolkami filtrów jedna pod drugą,
 * „Wyczyść” i „Pokaż”. Filtry działają od razu (jak na desktopie — zwykle w adresie strony), „Pokaż” tylko zamyka.
 * Na desktopie moduł pokazuje te same kontrolki w wierszu nad listą (`useIsPhone` wybiera wersję).
 */
export function MobileFilters({
  count,
  onClear,
  children,
  showLabel = 'Pokaż',
  className,
}: {
  /** liczba aktywnych filtrów (0 = brak pigułki) */
  count: number;
  /** „Wyczyść” w panelu (pokazywane, gdy coś jest wybrane) */
  onClear?: () => void;
  /** kontrolki filtrów (na pełną szerokość, jedna pod drugą) */
  children: ReactNode;
  showLabel?: string;
  className?: string;
}) {
  const [open, setOpen] = useState(false);
  const active = count > 0;
  return (
    <>
      <Button
        variant="ghost"
        size="l"
        icon={SlidersHorizontal}
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        className={cn('h-11', active && 'bg-accent-subtle text-accent hover:text-accent', className)}
      >
        Filtry
        {active && <CountPill count={count} tone="accent" label={`, aktywne: ${count}`} />}
      </Button>
      <Sheet
        open={open}
        onOpenChange={setOpen}
        side="bottom"
        title="Filtry"
        footer={
          <>
            {active && onClear && (
              <Button variant="ghost" size="l" icon={X} onClick={onClear} className="mr-auto">
                Wyczyść
              </Button>
            )}
            <Button variant="primary" size="l" onClick={() => setOpen(false)}>
              {showLabel}
            </Button>
          </>
        }
      >
        <div className="flex flex-col gap-4 [&_[role=combobox]]:h-11 [&_button]:min-h-11 [&_input]:h-11">
          {children}
        </div>
      </Sheet>
    </>
  );
}
